import { noTarget, isOfMetaType, isActiveFeature, isInactiveFeature, isShiftDown } from './utils/common_selectors';
import createSupplementaryPoints from './utils/create_supplementary_points';
import constrainFeatureMovement from './utils/constrain_feature_movement';
import doubleClickZoom from './utils/double_click_zoom';
import * as Constants from './utils/constants';
import moveFeatures from './utils/move_features';
import {calculateSnapTolerance, clearSnapMarkerOnMap, sanitizeSnapOptions, setSnapMarkerOnMap, type SnapHitKind} from './utils/CalculateSnapTolerance';
// import * as Utils from "../Utils";

import { drawState, drawModes, Source } from '../../Types';

import { circle, point, polygon, booleanPointInPolygon, pointToLineDistance, distance } from "@turf/turf";
import { GeoJSONFeature } from 'maplibre-gl';

const isVertex = isOfMetaType(Constants.meta.VERTEX);
const isMidpoint = isOfMetaType(Constants.meta.MIDPOINT);

const DirectSelect:drawModes = <drawModes>{};

DirectSelect.fireUpdate = function (state:drawState) {
  this.map.fire(Constants.events.UPDATE, {
    action: Constants.updateActions.CHANGE_COORDINATES,
    features: this.getSelected().map((f:any) => f.toGeoJSON())
  });
  // this.map._updateCoordinateTable(state.coordPath);
};

DirectSelect.fireActionable = function (state:drawState) {
  this.setActionableState({
    combineFeatures: true,
    uncombineFeatures: true,
    trash: true,
  });

};

DirectSelect.startDragging = function (state:drawState, e:any) {
  this.map.dragPan.disable();
  this.map.touchZoomRotate.disable();
  state.canDragMove = true;
  state.dragMoveLocation = e.lngLat;
};

DirectSelect.stopDragging = function (state:drawState) {
  state.canDragMove = false;
  this.map.dragPan.enable();
  this.map.touchZoomRotate.enable();
};

function parseDirectSelectCoordPath(coordPath: string): {
  vertexIndex: number;
  ringIndex: number;
} {
  const parts = coordPath.split('.').map((part) => Number(part));
  if (parts.length === 1 && Number.isFinite(parts[0])) {
    return { vertexIndex: parts[0], ringIndex: 0 };
  }
  if (parts.length >= 2) {
    const vertexIndex = parts[parts.length - 1];
    const ringIndex = parts[parts.length - 2];
    if (Number.isFinite(vertexIndex) && Number.isFinite(ringIndex)) {
      return { vertexIndex, ringIndex };
    }
  }
  return { vertexIndex: NaN, ringIndex: 0 };
}

DirectSelect.onVertex = function (state:drawState, e:any) {
  const about = e.featureTarget.properties;
  const isRightClick =
    e.originalEvent?.which === 3 || e.originalEvent?.button === 2;

  const selectedIndex = state.selectedCoordPaths.indexOf(<never>about.coord_path);
  if (!isShiftDown(e) && selectedIndex === -1) {
    state.selectedCoordPaths = [about.coord_path];
  } else if (isShiftDown(e) && selectedIndex === -1) {
    state.selectedCoordPaths.push(about.coord_path);
  }

  
  const selectedCoordinates = this.pathsToCoordinates(state.featureId, state.selectedCoordPaths);
  this.setSelectedCoordinates(selectedCoordinates);

  if (isRightClick) {
    e.originalEvent?.preventDefault?.();
    e.originalEvent?.stopPropagation?.();
    this.stopDragging(state);
    const coordPath = state.selectedCoordPaths[0];
    if (coordPath) {
      const { vertexIndex, ringIndex } = parseDirectSelectCoordPath(coordPath);
      const mapApi = this.map as {
        deleteEditGeometryVertex?: (
          vertexIndex: number,
          opts?: { featureId?: string; polygonRingIndex?: number }
        ) => boolean;
      };
      if (
        Number.isFinite(vertexIndex) &&
        typeof mapApi.deleteEditGeometryVertex === 'function' &&
        mapApi.deleteEditGeometryVertex(vertexIndex, {
          featureId: String(state.featureId),
          polygonRingIndex: ringIndex,
        })
      ) {
        state.selectedCoordPaths = [];
        this.clearSelectedCoordinates();
        this.fireActionable(state);
      }
    }
    return;
  }

  this.startDragging(state, e);

  const draws = this.map.drawTools.getAll().features;

  var featureCount = 0;
 
  switch (draws[0].geometry.type) {
    case 'MultiLineString':
    case 'LineString':
      for (const draw of draws) {
        if (draw.id === state.featureId) break;
        if (draw.geometry.type === 'MultiLineString') {
          featureCount += 1;
        } else if (draw.geometry.type === 'LineString') {
          featureCount += 1;
        }
      }
      break;

    case 'MultiPolygon':
    case 'Polygon':
      for (const draw of draws) {
        if (draw.id === state.featureId) break;
        if (draw.geometry.type === 'MultiPolygon') {

          for (const geometry of draw.geometry.coordinates) {
            featureCount += 1;
          }

        } else if (draw.geometry.type === 'Polygon') {
          featureCount += 1;
        }
      }
      break;

    case 'MultiPoint':
    case 'Point':
      for (const draw of draws) {
        if (draw.id === state.featureId) break;
        if (draw.geometry.type === 'MultiPoint') {
          featureCount += 1;
        } else if (draw.geometry.type === 'Point') {
          featureCount += 1;
        }

      }
      break;
  }


  if (state.selectedCoordPaths.length > 0) {
    try {
      var coordPath = state.selectedCoordPaths[0].split('.');
      switch (state.feature.type) {
        case 'MultiPolygon':
        case 'Polygon':
          if (coordPath.length === 3) coordPath[0] = featureCount + Number(coordPath[0]);
          if (coordPath.length < 3) coordPath = [featureCount, ...coordPath];

          break;
        case 'MultiLineString':
        case 'LineString':
          if (coordPath.length < 2) coordPath = [featureCount, 0, ...coordPath];
          if (coordPath.length < 3) coordPath = [featureCount, ...coordPath];
          break;
      }

      state.coordPath = coordPath;
      
      // var coordinatePanel = document.getElementsByClassName('geobox-gl-coordinate-main-div');
      // if (coordinatePanel[0]) {
      //   var partBtn = coordinatePanel[0].querySelectorAll(`[viewID="${coordPath[0]}${coordPath[1]}"]`);
      //   if (partBtn[0]) partBtn[0].click();
      //   var viewPort = coordinatePanel[0].querySelector(`#geoboxCoordinateViewport${coordPath[0]}${coordPath[1]}`);

      //   if (viewPort) viewPort.scrollTop = 40 * Number(coordPath[2]);
      //   setTimeout(() => {
      //     try {
      //       var selectedRow = viewPort.querySelectorAll(`[rownumber="${coordPath[2]}"]`)[0];
      //       if (selectedRow) selectedRow.click();
      //     } catch (error) {
            
      //     }
      //   }, 200);

      // }
    } catch (error) {

    }

  }

  if (e.type === 'touchstart'){
    // this.map._holdTapTimeout = 
    this.holdTapTimeout = setTimeout(() => {
      this.map.drawTools.trash();

      this.snapMarkerSource.features = [{
        "type": "Feature",
        "properties": {},
        "geometry": {
          "type": "Point",
          "coordinates": []
        }
      }];
  
      (<Source>this.map.getSource('geobox-gl-snap-marker')).setData(this.snapMarkerSource);

    }, 1000);
  }
  
};

DirectSelect.onMidpoint = function (state:drawState, e:any) {
  this.startDragging(state, e);
  const about = e.featureTarget.properties;
  state.feature.addCoordinate(about.coord_path, about.lng, about.lat);
  this.fireUpdate(state);
  state.selectedCoordPaths = [about.coord_path];
};

DirectSelect.pathsToCoordinates = function (featureId:string, paths:[]) {
  return paths.map(coord_path => ({ feature_id: featureId, coord_path }));
};

DirectSelect.onFeature = function (state:drawState, e:any) {
  state.selectedCoordPaths = [];
  this.startDragging(state, e);
};

DirectSelect.dragFeature = function (state: drawState, e:any, delta:any) {
  clearTimeout(this.holdTapTimeout);
  try {
    if (e.originalEvent.touches.length > 1) {
      this.stopDragging(state);
      return;
    }
  } catch (error) {}

  // moveFeatures(this.getSelected(), delta);
  // state.dragMoveLocation = e.lngLat;

  moveFeatures(this.getSelected(), delta);
  this.getSelected()
    .filter((feature:any) => feature.properties.isCircle)
    .map((circle:any) => circle.properties.center)
    .forEach((center:any) => {
      center[0] += delta.lng;
      center[1] += delta.lat;
    });
  state.dragMoveLocation = e.lngLat;
};

DirectSelect.dragVertex = function (state:drawState, e:any, delta:any) {
  clearTimeout(this.holdTapTimeout);
  try {
    if (e.originalEvent.touches.length > 1) {
      this.stopDragging(state);
      return;
    }
  } catch (error) {}
  
  const selectedCoords = state.selectedCoordPaths.map(coord_path => state.feature.getCoordinate(coord_path));
  const selectedCoordPoints = selectedCoords.map(coords => ({
    type: Constants.geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: Constants.geojsonTypes.POINT,
      coordinates: coords
    }
  }));

  
  if (state.feature.properties.isCircle) {
    const center = state.feature.properties.center;
    const movedVertex = [e.lngLat.lng, e.lngLat.lat];
    const radius = distance(point(center), point(movedVertex), {units: 'kilometers'});
    const circleFeature = circle(center, radius);
    state.feature.incomingCoords(circleFeature.geometry.coordinates);
    state.feature.properties.radiusInKm = radius;
  } else {
    const constrainedDelta = constrainFeatureMovement(selectedCoordPoints, delta);
    for (let i = 0; i < selectedCoords.length; i++) {
      const coord = selectedCoords[i];
      state.feature.updateCoordinate(state.selectedCoordPaths[i], coord[0] + constrainedDelta.lng, coord[1] + constrainedDelta.lat);
    }
  }
};

DirectSelect.clickNoTarget = function () {
  this.changeMode(Constants.modes.SIMPLE_SELECT);
};

DirectSelect.clickInactive = function (state:drawState, e:any) {
  doubleClickZoom.disable(this);

  const isctrlKeyClick = e.originalEvent.ctrlKey;
 
  const selectedFeatureIds = this.getSelectedIds();
  const featureId = e.featureTarget.properties.id;
  const isFeatureSelected = this.isSelected(featureId);

  if (!isctrlKeyClick) {
    this.changeMode(Constants.modes.SIMPLE_SELECT);
    this.select(featureId);
    this.changeMode(Constants.modes.DIRECT_SELECT, {
      featureId: featureId
    });
  } else if (!isFeatureSelected && isctrlKeyClick) {
    const oldID = this.getSelectedIds();
    this.changeMode(Constants.modes.SIMPLE_SELECT);
    this.select(oldID[0]);
    this.select(featureId);
  }

  this.doRender(featureId);
};

DirectSelect.clickActiveFeature = function (state:drawState, e:any) {
  state.selectedCoordPaths = [];
  this.clearSelectedCoordinates();
  state.feature.changed();

  const draws = this.map.drawTools.getAll().features;
  var featureCount = 0;
  var innerFeatureCount = 0;
  var snapTolerance = 5 * ((Math.cos((this.map.getCenter().lat * Math.PI) / 180.0) * 2 * Math.PI * 6378137) / (256 * 2 ** this.map.getZoom())) <
       99999
      ? 5 *
        ((Math.cos((this.map.getCenter().lat * Math.PI) / 180.0) *
          2 *
          Math.PI *
          6378137) /
          (256 * 2 ** this.map.getZoom()))
      : 99999;

  

  // switch (draws[0].geometry.type) {
  //   case 'MultiLineString':
  //   case 'LineString':
      
  //     for (const draw of draws) {
  //       if (draw.geometry.type === 'MultiLineString') {
  //         innerFeatureCount = 0;
  //         for (const geometry of draw.geometry.coordinates) {
  //           let dist = pointToLineDistance([state.dragMoveLocation.lng, state.dragMoveLocation.lat], <any>geometry, { units: 'meters' });
  //           if (dist < snapTolerance ) {
  //             var coordinatePanel = document.getElementsByClassName('geobox-gl-coordinate-main-div');
  //             if (coordinatePanel[0]) {
  //               var partBtn = coordinatePanel[0].querySelectorAll(`[viewID="${featureCount}${innerFeatureCount}"]`);
  //               if (partBtn[0]) partBtn[0].click();
  //               return;
  //             }
  //           }
  //           innerFeatureCount+=1;
  //         }
          
  //         featureCount += 1;
  //       } else if (draw.geometry.type === 'LineString') {
  //         let dist = pointToLineDistance([state.dragMoveLocation.lng, state.dragMoveLocation.lat], draw.geometry.coordinates, { units: 'meters' });
  //         if (dist < snapTolerance ) {
  //           var coordinatePanel = document.getElementsByClassName('geobox-gl-coordinate-main-div');
  //           if (coordinatePanel[0]) {
  //             var partBtn = coordinatePanel[0].querySelectorAll(`[viewID="${featureCount}0"]`);
  //             if (partBtn[0]) partBtn[0].click();
  //             return;
  //           } 
  //         }
  //         featureCount += 1;
  //       }
  //     }
  //     break;

  //   case 'MultiPolygon':
  //   case 'Polygon':
  //     var clickedPoint = point([state.dragMoveLocation.lng, state.dragMoveLocation.lat]);
  //     for (const draw of draws) {
  //       if (draw.geometry.type === 'MultiPolygon') {
  //         for (const geometry of draw.geometry.coordinates) {
  //           var extentPolygon = polygon(geometry);
  //           if (booleanPointInPolygon(clickedPoint, extentPolygon)) {
  //             var coordinatePanel = document.getElementsByClassName('geobox-gl-coordinate-main-div');
  //             if (coordinatePanel[0]) {
  //               var partBtn = coordinatePanel[0].querySelectorAll(`[viewID="${featureCount}0"]`);
  //               if (partBtn[0]) partBtn[0].click();
  //               return;
  //             }
  //           }
    
  //           featureCount += 1;
  //         }
    
  //       } else if (draw.geometry.type === 'Polygon') {
  //         for (const geometry of draw.geometry.coordinates) {
  //           var extentPolygon = polygon([geometry]);
      
  //           if (booleanPointInPolygon(clickedPoint, extentPolygon)) {
  //             var coordinatePanel = document.getElementsByClassName('geobox-gl-coordinate-main-div');
  //             if (coordinatePanel[0]) {
  //               var partBtn = coordinatePanel[0].querySelectorAll(`[viewID="${featureCount}0"]`);
  //               if (partBtn[0]) partBtn[0].click();
  //               return;
  //             }
  //           }
    
  //           featureCount += 1;
            
  //         }
  //       }
  //     }
  //     break;

  //   // case 'MultiPoint':
  //   // case 'Point':

  //   // console.log(5555555555555)
  //   //   for (const draw of draws) {
  //   //     if (draw.geometry.type === 'MultiPoint') {
  //   //       innerFeatureCount = 0;
  //   //       for (const geometry of draw.geometry.coordinates) {
  //   //         let dist = distance(geometry, [state.dragMoveLocation.lng, state.dragMoveLocation.lat], { units: 'meters' });
  //   //         if (dist < snapTolerance ) {
  //   //           var coordinatePanel = document.getElementsByClassName('geobox-gl-coordinate-main-div');
  //   //           if (coordinatePanel[0]) {
  //   //             var partBtn = coordinatePanel[0].querySelectorAll(`[viewID="0${featureCount}"]`);
  //   //             if (partBtn[0]) partBtn[0].click();
  //   //             return;
  //   //           }
  //   //         }
  //   //         innerFeatureCount += 1;
  //   //         featureCount += 1;
  //   //       }
  //   //     } else if (draw.geometry.type === 'Point') {
  //   //       for (const geometry of draw.geometry.coordinates) {
  //   //         let dist = distance(geometry, [state.dragMoveLocation.lng, state.dragMoveLocation.lat], { units: 'meters' });
  //   //         if (dist < snapTolerance ) {
  //   //           var coordinatePanel = document.getElementsByClassName('geobox-gl-coordinate-main-div');
  //   //           if (coordinatePanel[0]) {
  //   //             var partBtn = coordinatePanel[0].querySelectorAll(`[viewID="0${featureCount}"]`);
  //   //             if (partBtn[0]) partBtn[0].click();
  //   //             return;
  //   //           }
  //   //         }
  //   //         featureCount += 1;
  //   //       }
  //   //     }

  //   //   }
  //   //   break;
  // }


  // if (state.selectedCoordPaths.length > 0) {
  //   try {
  //     var coordPath = state.selectedCoordPaths[0].split('.');
  //     switch (state.feature.type) {
  //       case 'MultiPolygon':
  //       case 'Polygon':
  //         if (coordPath.length === 3) coordPath[0] = featureCount + Number(coordPath[0]);
  //         if (coordPath.length < 3) coordPath = [featureCount, ...coordPath];

  //         break;
  //       case 'MultiLineString':
  //       case 'LineString':
  //         if (coordPath.length < 2) coordPath = [featureCount, 0, ...coordPath];
  //         if (coordPath.length < 3) coordPath = [featureCount, ...coordPath];
  //         break;
  //     }

 
  //     var coordinatePanel = document.getElementsByClassName('geobox-gl-coordinate-main-div');
  //     if (coordinatePanel[0]) {
  //       var partBtn = coordinatePanel[0].querySelectorAll(`[viewID="${coordPath[0]}${coordPath[1]}"]`);
  //       if (partBtn[0]) partBtn[0].click();
  //       var viewPort = coordinatePanel[0].querySelector(`#geoboxCoordinateViewport${coordPath[0]}${coordPath[1]}`);

  //       if (viewPort) viewPort.scrollTop = 40 * Number(coordPath[2]);
  //       setTimeout(() => {
  //         var selectedRow = viewPort.querySelectorAll(`[rownumber="${coordPath[2]}"]`)[0];
  //         if (selectedRow) selectedRow.click();
  //       }, 200);

  //     }
  //   } catch (error) {

  //   }

  // }
};


DirectSelect.onSetup = function (opts:any) {
  const featureId = opts.featureId;
  const feature = this.getFeature(featureId);

  if (!feature) {
    // throw new Error('You must provide a featureId to enter direct_select mode');
  }

  if (feature && feature.type === Constants.geojsonTypes.POINT) {
    // throw new TypeError('direct_select mode doesn\'t handle point features');
  }

  const state: any = {
    featureId,
    feature,
    dragMoveLocation: opts.startPos || null,
    dragMoving: false,
    canDragMove: false,
    options: sanitizeSnapOptions(this._ctx.options),
    selectedCoordPaths: opts.coordPath ? [opts.coordPath] : []
  };

  const optionsChangedCallBAck = (options: drawState['options']) => {
    state.options = sanitizeSnapOptions(options);
    if (!state.options.snap) {
      clearSnapMarkerOnMap(this.map);
    }
  };
  state.optionsChangedCallBAck = optionsChangedCallBAck;
  this.map.on('draw.snap.options_changed', optionsChangedCallBAck);

  this.setSelectedCoordinates(this.pathsToCoordinates(featureId, state.selectedCoordPaths));
  this.setSelected(featureId);
  doubleClickZoom.disable(this);

  this.setActionableState({
    trash: true
  });

  this.map.getCanvasContainer().style.cursor = "grab";
  this.updateUIClasses({ mouse: 'grab' });

  try {
    this.snapMarkerSource = (<Source>this.map.getSource('geobox-gl-snap-marker'))._data;
  } catch {
    /* source may not exist yet */
  }

  try {
    (this.map as any).scheduleUpdateSnapLayers?.();
  } catch {
    /* ignore */
  }

  return state;
};

DirectSelect.onStop = function (state?: drawState) {
  doubleClickZoom.enable(this);
  this.clearSelectedCoordinates();
  clearSnapMarkerOnMap(this.map);
  try {
    if (state?.optionsChangedCallBAck) {
      (this.map as any).off('draw.snap.options_changed', state.optionsChangedCallBAck);
    }
  } catch {
    /* ignore */
  }
};

DirectSelect.toDisplayFeatures = function (state:drawState, geojson:GeoJSONFeature, push:any) {
  const featureId = String(geojson.properties?.id ?? geojson.id ?? '');
  if (String(state.featureId) === featureId) {
    geojson.properties.active = Constants.activeStates.ACTIVE;
    push(geojson);
    createSupplementaryPoints(geojson, {
      map: this.map,
      midpoints: true,
      selectedPaths: state.selectedCoordPaths
    }).forEach(push);
  } else {
    geojson.properties.active = Constants.activeStates.INACTIVE;
    push(geojson);
  }
  this.fireActionable(state);
};

DirectSelect.onTrash = function (state:drawState) {
  // Uses number-aware sorting to make sure '9' < '10'. Comparison is reversed because we want them
  // in reverse order so that we can remove by index safely.
  state.selectedCoordPaths
    .sort((a, b) => b.localeCompare(a, 'en', { numeric: true }))
    .forEach(id => state.feature.removeCoordinate(id));
  
  state.selectedCoordPaths = [];
  this.clearSelectedCoordinates();
  this.fireActionable(state);
  if (state.feature.isValid() === false) {
    this.deleteFeature([state.featureId]);
    this.changeMode(Constants.modes.SIMPLE_SELECT, {});
  }

  this.fireUpdate(state);

  // this.snapMarkerSource.features = [{
  //   "type": "Feature",
  //   "properties": {},
  //   "geometry": {
  //     "type": "Point",
  //     "coordinates": []
  //   }
  // }];

  // this.map.getSource('geobox-gl-snap-marker').setData(this.snapMarkerSource);
};

DirectSelect.removeLastVertex = function (state:drawState) {
  if (state.currentVertexPosition > 2) {
    state.currentVertexPosition--;
    state.line.removeCoordinate(`${state.currentVertexPosition}`);
  } else {
    this.deleteFeature([state.line.id], { silent: true });
    this.changeMode(Constants.modes.SIMPLE_SELECT);
  }
}


DirectSelect.onCombineFeatures = function (state:drawState) {
  const selectedFeatures = this.getSelected();

  if (selectedFeatures.length === 0 || selectedFeatures.length < 2) {
    const featureId = this.getSelectedIds();
    this.changeMode(Constants.modes.SIMPLE_SELECT, {
      featureId
    })
    return;
  }

  const coordinates = [], featuresCombined = [];
  const featureType = selectedFeatures[0].type.replace('Multi', '');

  for (let i = 0; i < selectedFeatures.length; i++) {
    const feature = selectedFeatures[i];

    if (feature.type.replace('Multi', '') !== featureType) {
      return;
    }
    if (feature.type.includes('Multi')) {
      feature.getCoordinates().forEach((subcoords:any) => {
        coordinates.push(subcoords);
      });
    } else {
      coordinates.push(feature.getCoordinates());
    }

    featuresCombined.push(feature.toGeoJSON());
  }

  if (featuresCombined.length > 1) {
    const multiFeature = this.newFeature({
      type: Constants.geojsonTypes.FEATURE,
      properties: featuresCombined[0].properties,
      geometry: {
        type: `Multi${featureType}`,
        coordinates
      }
    });

    this.addFeature(multiFeature);
    this.deleteFeature(this.getSelectedIds(), { silent: true });
    this.setSelected([multiFeature.id]);

    this.map.fire(Constants.events.COMBINE_FEATURES, {
      createdFeatures: [multiFeature.toGeoJSON()],
      deletedFeatures: featuresCombined
    });
  }
  this.fireActionable();
  const featureId = this.getSelectedIds();
  this.changeMode(Constants.modes.SIMPLE_SELECT, {
    featureId
  })
  this.fireUpdate(state);
};

DirectSelect.onUncombineFeatures = function (state:drawState) {
  const selectedFeatures = this.getSelected();
  if (selectedFeatures.length === 0) return;

  const createdFeatures:any[] = [];
  const featuresUncombined:any[] = [];

  for (let i = 0; i < selectedFeatures.length; i++) {
    const feature = selectedFeatures[i];

    if (this.isInstanceOf('MultiFeature', feature)) {
      feature.getFeatures().forEach((subFeature:any) => {
        this.addFeature(subFeature);
        subFeature.properties = feature.properties;
        createdFeatures.push(subFeature.toGeoJSON());
        this.select([subFeature.id]);
      });
      this.deleteFeature(feature.id, { silent: true });
      featuresUncombined.push(feature.toGeoJSON());
    }
  }

  if (createdFeatures.length > 1) {
    this.map.fire(Constants.events.UNCOMBINE_FEATURES, {
      createdFeatures,
      deletedFeatures: featuresUncombined
    });
  }
  this.fireActionable();
  const featureId = this.getSelectedIds();
  this.changeMode(Constants.modes.SIMPLE_SELECT, {
    featureId
  })
  this.fireUpdate(state);
};

DirectSelect.onMouseMove = function (state:drawState, e:any) {
  const isFeature = isActiveFeature(e);
  const isInactiveFeatures = isInactiveFeature(e);
  const onVertex = isVertex(e);
  const onMidpoint = isMidpoint(e);
  // const noCoords = state.selectedCoordPaths.length === 0;
  this.map.getCanvasContainer().style.cursor = "grab";

  if (isFeature || isInactiveFeatures  /*&& noCoords*/) this.map.getCanvasContainer().style.cursor = "pointer";// this.updateUIClasses({ mouse: Constants.cursors.GRAB });
  else if (onMidpoint) this.map.getCanvasContainer().style.cursor = "cell";
  else if (onVertex) {
    this.map.getCanvasContainer().style.cursor = "move";
    // this.updateUIClasses({ mouse: 'move' });
  }
  else this.updateUIClasses({ mouse: Constants.cursors.NONE });
  this.stopDragging(state);

  // Skip render
  return true;
};

DirectSelect.onMouseOut = function (state:drawState) {
  // As soon as you mouse leaves the canvas, update the feature
  // this.updateUIClasses({ mouse: 'grab' });
  // if (state.dragMoving) this.fireUpdate(state);

  // //Skip render
  return true;
};


DirectSelect.onTouchStart = DirectSelect.onMouseDown = function (state:drawState, e:any) {
  clearTimeout(this.holdTapTimeout);
  try {
    if (e.originalEvent.touches.length > 1) {
      this.stopDragging(state);
      return;
    }
  } catch (error) {}

  this.updateUIClasses({ mouse: 'grab' });
  if (isVertex(e)) return this.onVertex(state, e);
  if (isActiveFeature(e)) return this.onFeature(state, e);
  if (isMidpoint(e)) return this.onMidpoint(state, e);

};



DirectSelect.onDrag = function (state:drawState, e:any) {
  clearTimeout(this.holdTapTimeout);
  try {
    if (e.originalEvent.touches.length > 1) {
      this.stopDragging(state);
      return;
    }
  } catch (error) {}

  if (state.canDragMove !== true) return;
  state.dragMoving = true;
  e.originalEvent.stopPropagation();

  let { lng, lat } = e.lngLat;
  let minDistance = Infinity;
  let desiredCoord: number[] | undefined;
  let snapKind: SnapHitKind | undefined;

  if (state.selectedCoordPaths.length > 0 && state.options.snap) {
    [minDistance, desiredCoord, snapKind] = calculateSnapTolerance(this.map, e, state);
  }

  const snapLocked = Boolean(
    state.selectedCoordPaths.length > 0 &&
      state.options.snap &&
      desiredCoord &&
      Number.isFinite(minDistance) &&
      minDistance <= (state.options.snapTolerance ?? Infinity)
  );

  if (snapLocked && desiredCoord) {
    lng = desiredCoord[0];
    lat = desiredCoord[1];
  }

  if (state.selectedCoordPaths.length > 0 && state.options.snap) {
    setSnapMarkerOnMap(this.map, lng, lat, {
      locked: snapLocked,
      kind: snapLocked ? snapKind ?? null : null,
    });
  } else {
    clearSnapMarkerOnMap(this.map);
  }

  const delta = {
    lng: lng - state.dragMoveLocation.lng,
    lat: lat - state.dragMoveLocation.lat
  };

  if (state.selectedCoordPaths.length > 0) {
    if (state.feature.type === 'MultiPolygon') {
      const coordPath = state.selectedCoordPaths[0].split('.');
      state.feature.features[coordPath[0]].coordinates[coordPath[1]][coordPath[2]] = [state.dragMoveLocation.lng, state.dragMoveLocation.lat];
      // this.dragFeature(state, e, delta)
    } else if (state.feature.type === 'Polygon') {
      const coordPath = state.selectedCoordPaths[0].split('.');
      state.feature.coordinates[coordPath[0]][state.selectedCoordPaths[0].split('.')[1]] = [state.dragMoveLocation.lng, state.dragMoveLocation.lat];
    } else if (state.feature.type === 'MultiLineString') {
      const coordPath = state.selectedCoordPaths[0].split('.');
      state.feature.features[coordPath[0]].coordinates[coordPath[1]] = [state.dragMoveLocation.lng, state.dragMoveLocation.lat];
    } else if (state.feature.type === 'LineString') {
      state.feature.coordinates[state.selectedCoordPaths[0]] = [state.dragMoveLocation.lng, state.dragMoveLocation.lat];
    }
    this.dragVertex(state, e, delta);
  } else this.dragFeature(state, e, delta);

  state.dragMoveLocation = { lng: lng, lat: lat };

};

DirectSelect.onClick = function (state:drawState, e:any) {
  this.updateUIClasses({ mouse: 'grab' });
  if (noTarget(e)) return this.clickNoTarget(state, e);
  if (isActiveFeature(e)) return this.clickActiveFeature(state, e);
  if (isInactiveFeature(e)) return this.clickInactive(state, e);
  this.stopDragging(state);
};

DirectSelect.onTap = function (state: drawState, e: any) {
  if (noTarget(e)) return this.clickNoTarget(state, e);
  if (isActiveFeature(e)) return this.clickActiveFeature(state, e);
  if (isInactiveFeature(e)) return this.clickInactive(state, e);
};

DirectSelect.onTouchEnd = DirectSelect.onMouseUp = function (state: drawState) {
  clearTimeout(this.holdTapTimeout);
  this.updateUIClasses({ mouse: 'grab' });
  if (state.dragMoving) {
    this.fireUpdate(state);
  }
  this.stopDragging(state);
};

export default DirectSelect;

